import React from 'react';
import {
  useOnboardingContext,
  useSnackbarContext,
  useEventTrackerContext,
  useLinesContext,
} from '../../../contexts';
import { updateProduct } from '../../API/product';
import { convertToInt, formatNumber, numberValidation } from '../../../utils';
import { Field } from 'formik';
import messages from '../../../messages';
import * as yup from 'yup';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import NumberFormatTextField from '../../misc/NumberFormatTextField';
import cloneDeep from 'lodash.clonedeep';
import ProductDetails from './product-details/ProductDetails';

const useStyles = makeStyles((theme) => ({
  field: {
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
    },
  },
}));

export default function NextBatch() {
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { setLoading, goForward } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();
  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { nextBatch: string }) {
    const nextBatch = convertToInt(values.nextBatch);
    if (!newestProduct) {
      return snackbar.show(messages.product.errors.notFoundUpdate, 'error');
    }
    try {
      if (newestProduct?.nextBatch !== nextBatch) {
        setLoading(true);
        await updateProduct(newestProduct?.id, {
          numUnitsNextBatch: nextBatch,
        });
        const updatedProducts = cloneDeep(products).map((product) => {
          if (product.id === newestProduct.id) {
            product['nextBatch'] = nextBatch;
          }
          return product;
        });
        setProducts(updatedProducts);
      }
      trackEvent({ event: 'entered_future_unit_no', batch_amount: nextBatch });
      goForward();
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{
        nextBatch: newestProduct?.nextBatch
          ? formatNumber(newestProduct.nextBatch)
          : '',
      }}
      validationSchema={yup.object({
        nextBatch: numberValidation,
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <ProductDetails product={newestProduct} step={4}>
            <Field
              name="nextBatch"
              label="Units to be purchased"
              component={NumberFormatTextField}
              variant="outlined"
              fullWidth
              className={classes.field}
            />
          </ProductDetails>
        );
      }}
    />
  );
}
